import React from 'react';
import '../App.css';
import CarChgNight from '../assets/carchgnight.webp'
import MapWPins from '../assets/mapwpins.webp'
import {redirectToStore} from './Helpers'

const income = "Earn extra income by sharing your charger with nearby EV drivers. Results vary based on location, usage, and pricing. Sharing your charger is not only convenient but also a rewarding way to generate income on your property. Embrace the opportunity to contribute to sustainable transportation while earning from your idle charger!";

export default function LetsStart() {
  return (
    <section className="section section-flush-top">
      <div className="container feature-grid">
        <article className="feature feature-blue">
          <h3>Reserve A Charger Directly From Our App: Easy And Fast!</h3>
          <p>Locate a charger with ease and reserve it quickly using the Gridspot app. Power usage can be paid for with any major credit card using our simple user interface. No more worries about broken or occupied chargers. Take the guesswork out of EV charging with Gridspot.</p>
          <button type="button" className="btn btn-outline" onClick={redirectToStore}>Download App</button>
          <img src={MapWPins} alt="Map with Gridspot charger pins" loading="lazy" width="1200" height="800"/>
        </article>
        <article className="feature feature-dark">
          <h3>Advertise Your Charger To Other Users</h3>
          <p>{income}</p>
          <button type="button" className="btn btn-outline" onClick={redirectToStore}>Download App</button>
          <img src={CarChgNight} alt="Electric car plugged into a wall-mounted charger" loading="lazy" width="1200" height="800"/>
        </article>
      </div>
    </section>
  )
}
